/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import ErrorMetadata from 'components/PageMetadata/ErrorMetadata';
import ErrorMessage from 'components/ErrorMessage';
import IconfontStyleTag from 'components/IconfontStyleTag';
import { navbar, NAVBAR_THEME } from 'lib/navbar';
import getThemesCssPath from 'lib/getThemesCssPath';

const PAGE_TYPES = {
  404: 'NotFound',
  500: 'InternalServerError',
};

const navbarConfig = {
  theme: ({ vertical }) => {
    switch (vertical) {
      case 'today':
        return NAVBAR_THEME.TRANSPARENT;
      case 'news':
      case 'msnbc':
        return NAVBAR_THEME.VERTICAL;
      default:
        return NAVBAR_THEME.LIGHT;
    }
  },
};

function ErrorPage({ statusCode, vertical }) {
  const themesCssPath = getThemesCssPath(vertical);

  return (
    <>
      <Head>
        {themesCssPath && (
          <link href={themesCssPath} rel="stylesheet" key={themesCssPath} />
        )}
        <IconfontStyleTag />
      </Head>

      <div>
        <ErrorMetadata pageType={PAGE_TYPES[statusCode] || PAGE_TYPES[500]} />
        <ErrorMessage code={statusCode} vertical={vertical} />
      </div>
    </>
  );
}

ErrorPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  vertical: PropTypes.string,
};

ErrorPage.defaultProps = {
  vertical: '',
};

ErrorPage.getInitialProps = ({ res, err }) => {
  const resStatusCode = res && res.statusCode;
  const errStatusCode = err && err.statusCode;
  return {
    statusCode: resStatusCode || errStatusCode || 500,
  };
};

export default navbar(navbarConfig)(ErrorPage);
/* eslint-enable react/jsx-filename-extension */
